import { Outlet } from "react-router-dom";
import AdminGuard from "@/components/feature/AdminGuard";
import AdminErrorBoundary from "@/components/feature/AdminErrorBoundary";

export default function AdminLayout() {
  return (
    <AdminGuard>
      <AdminErrorBoundary>
        <Outlet />
      </AdminErrorBoundary>
    </AdminGuard>
  );
}